module.exports = __webpack_public_path__ + "img/list-device.c447ef29.png";